export enum FontStyle {
  Normal = 'normal',
  Bold = 'bold',
}

export interface FontOptions<TFontSize, TFontColor> {
  fontSize: TFontSize;
  color: TFontColor;
  fontFamily: string;
  fontStyle: FontStyle;
}

export class FontBuilder<TFontSize, TFontColor> {
  private fontSize: TFontSize;
  private color: TFontColor;
  private fontFamily: string;
  private fontStyle: FontStyle;

  constructor(
    defaultFontSize: TFontSize,
    defaultFontColor: TFontColor,
    defaultFontFamily = 'DM Sans',
  ) {
    this.fontSize = defaultFontSize;
    this.color = defaultFontColor;
    this.fontFamily = defaultFontFamily;
    this.fontStyle = FontStyle.Normal;
  }

  setFontSize(size: TFontSize): this {
    this.fontSize = size;
    return this;
  }

  setFontStyle(style: FontStyle): this {
    this.fontStyle = style;
    return this;
  }

  setFontColor(color: TFontColor): this {
    this.color = color;
    return this;
  }

  build(): FontOptions<TFontSize, TFontColor> {
    return {
      fontSize: this.fontSize,
      color: this.color,
      fontFamily: this.fontFamily,
      fontStyle: this.fontStyle,
    };
  }

  static create<TFontSize, TFontColor>(
    defaultFontSize: TFontSize,
    defaultFontColor: TFontColor,
    defaultFontFamily = 'DM Sans',
  ) {
    return new FontBuilder<TFontSize, TFontColor>(
      defaultFontSize,
      defaultFontColor,
      defaultFontFamily,
    );
  }
}
